module.exports = {
  request: {
    maxRetryError: 5,
    timeout: 50000,
  },
  api: {
    mts: 'http://localhost:44302/api/'
    // mts: 'https://h41.cnnd.vn/mts-api/',
  },
};
